import { Component, OnInit, ViewChild } from '@angular/core';

import { Observable, forkJoin } from 'rxjs';

import { TwcPopupComponent } from '@topcon/twc-angular';

import { ToastService } from '@mirage-projects/cw-commons';
import { Group, PermAccessLevel } from '@mirage-projects/cw-models';

import { PermissionsEditorService } from '../permissions-editor.service';

/**
 * This component displays the groups list in order to be added to the list
 */
@Component({
    templateUrl: './add-group-popup.component.html',
    styleUrls: ['../permissions-element-list.scss'],
    standalone: false,
})
export class AddGroupPopupComponent implements OnInit {
    groupList: Group[] | undefined;
    selectedGroups: string[] = [];
    @ViewChild(TwcPopupComponent, { static: false }) addGroupPopup!: TwcPopupComponent;

    constructor(
        public permissionsEditorService: PermissionsEditorService,
        private toastService: ToastService
    ) {}

    ngOnInit(): void {
        this.groupList = this.permissionsEditorService.allGroups;
    }

    /**
     * If the group is already added to the group list we do nothing
     * If the group is selected, it will be removed from the selectedGroup list
     * If the group is not selected, it will be added to the selectedGroup list
     * @param groupUid: Group uid
     */
    onSelect(groupUid: string): void {
        if (this.isGroupAlreadyAdded(groupUid)) {
            return;
        }
        if (this.isSelectedGroupId(groupUid)) {
            this.selectedGroups = this.selectedGroups.filter((uId) => uId !== groupUid);
        } else {
            this.selectedGroups.push(groupUid);
        }
    }

    closePopup(): void {
        this.addGroupPopup.onClose();
    }

    /**
     * Add Groups selecteds to the group list adding the permissions.
     * When all permissions are added, the group list will be updated
     */
    addGroups(): void {
        this.closePopup();
        const observablesAddPerm: Observable<void>[] = this.selectedGroups.map((groupUid) =>
            this.permissionsEditorService.addGroupPermission(groupUid, PermAccessLevel.READONLY)
        );
        this.permissionsEditorService.isLoadingGroupList = true;

        forkJoin(observablesAddPerm).subscribe({
            next: () => {
                this.toastService.generic('PERMISSION_DIALOG.ADDED_GROUP_PERMISSIONS');
                this.permissionsEditorService.loadGroups();
            },
            error: () => {
                this.permissionsEditorService.loadGroups();
                this.toastService.error('PERMISSION_DIALOG.ERROR_ADDED_GROUP_PERMISSIONS');
            },
        });
    }

    /**
     * Returns true if the group is already added to the list
     */
    isGroupAlreadyAdded(groupUid: string): boolean {
        return this.permissionsEditorService.groupPermissionList.some((g) => g.id === groupUid);
    }

    isSelectedGroupId(groupUid: string): boolean {
        return this.selectedGroups.some((uId) => uId === groupUid);
    }
}
